import { FilterName } from '../../__generated__/fed-graphql-types'
import { SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_filterPills_FilterPill } from '../../contexts/search-results-context/query/__generated__/search-results-facets.fed.query'

/**
 * Reorder the list putting any unknown pills at the end.
 */
export const reorderFilterPills = (
    filterPills: ReadonlyArray<SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_filterPills_FilterPill> | null,
    selectedFiltersOrder: FilterName[]
): SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_filterPills_FilterPill[] | null => {
    if (!filterPills) return null

    const reordered = [...filterPills].sort((pill1, pill2) => {
        const idx1 = selectedFiltersOrder.findIndex((pill) => pill1.filter.includes(pill))
        const idx2 = selectedFiltersOrder.findIndex((pill) => pill2.filter.includes(pill))

        if (idx1 >= 0) {
            if (idx2 >= 0) {
                return idx1 - idx2
            } else {
                return -1
            }
        } else if (idx2 > 0) {
            return 1
        } else {
            return 0
        }
    })

    const removedDuplicates = [...new Set(reordered)]

    return removedDuplicates.length > 0 ? removedDuplicates : null
}

export const updateSelectedFiltersOrder = (previousFilters: FilterName[], lastSelected: FilterName | undefined) => {
    if (!lastSelected) return previousFilters

    if (lastSelected) {
        const updatedCurrentValues = previousFilters.filter((filterName) => filterName !== lastSelected)
        return [lastSelected, ...updatedCurrentValues]
    }

    return previousFilters
}
